import { tx as translateInterfaceText } from '@/utils/i18n';
import React from 'react';
import { VoxuyForm } from './VoxuyForm';
import { ActiveCampaignForm } from './ActiveCampaignForm';
import { LeadloversForm } from './LeadloversForm';
import { MetaPixelForm } from './MetaPixelForm';
import { SimpleIntegrationForm } from './SimpleIntegrationForm';

/**
 * Renderiza o formulário correto baseado no nameId da integração
 */
export const renderIntegrationForm = (integrationNameId: string) => {
  switch (integrationNameId) {
    case 'voxuy':
      return <VoxuyForm />;

    case 'activecampaign':
      return <ActiveCampaignForm />;

    case 'leadlovers':
      return <LeadloversForm />;

    case 'sellflux':
      return <SimpleIntegrationForm companyNameId="sellflux" companyName="SellFlux" />;

    case 'zapp-rapido':
      return <SimpleIntegrationForm companyNameId="zapp-rapido" companyName="Zapp Rápido" />;

    case 'smsfunnel':
      return <SimpleIntegrationForm companyNameId="smsfunnel" companyName="SMS Funnel" />;

    case 'bot-conversa':
      return <SimpleIntegrationForm companyNameId="bot-conversa" companyName="BotConversa" />;

    case 'builderall':
      return <SimpleIntegrationForm companyNameId="builderall" companyName="Builderall" />;

    case 'notificacoes-inteligentes':
      return <SimpleIntegrationForm companyNameId="notificacoes-inteligentes" companyName="Notificações Inteligentes" />;

    case 'meta-pixel':
      return <MetaPixelForm />;

    default:
      return (
        <div className="text-center py-8 text-gray-500">
          <p>{translateInterfaceText("Formulário não disponível para esta integração.")}</p>
        </div>
      );
  }
};
